export type Language = 'auto' | 'ar' | 'be' | 'bg' | 'bs' | 'ca' | 'cs' | 'da' | 'de' | 'el' | 'en' | 'es' | 'et' | 'fi' | 'fr' | 'hi' | 'hr' | 'hu' | 'it' | 'ko' | 'lb' | 'lt' | 'lv' | 'mk' | 'nl' | 'no' | 'pl' | 'pt' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sv' | 'tr' | 'uk' | 'zh';

export interface NamedTranslation {
  language: string,
  boxStart: string,
  boxInProgress: string,
  boxCompleted: string,
  endPrivacyPolicy: string,
  ariaLabelStart?: string,
  ariaLabelRunning?: string,
  ariaLabelDone?: string,
  srRunning?: string,
  srDone?: string,
  srFailed?: string,
  srExpired?: string,
  srTrustcaptcha?: string,
  srPrivacy?: string,
  srFailureReasonPrefix?: string,
  errorUnknown?: string,
  errorCommunicationFailure?: string,
  errorPowFailure?: string,
  errorPaymentRequired?: string,
  errorLocked?: string,
}

function mapTranslation(currentLanguage: string, array: readonly string[]): NamedTranslation {
  return {
    language: currentLanguage,
    boxStart: array[0],
    boxInProgress: array[1],
    boxCompleted: array[2],
    endPrivacyPolicy: array[3],
    ariaLabelStart: (array[4] || translations['en'][4]),
    ariaLabelRunning: (array[5] || translations['en'][5]),
    ariaLabelDone: (array[6] || translations['en'][6]),
    srRunning: (array[7] || translations['en'][7]),
    srDone: (array[8] || translations['en'][8]),
    srFailed: (array[9] || translations['en'][9]),
    srExpired: (array[10] || translations['en'][10]),
    srTrustcaptcha: (array[11] || translations['en'][11]),
    srPrivacy: (array[12] || translations['en'][12]),
    srFailureReasonPrefix: (array[13] || translations['en'][13]),
    errorUnknown: (array[14] || translations['en'][14]),
    errorCommunicationFailure: (array[15] || translations['en'][15]),
    errorPowFailure: (array[16] || translations['en'][16]),
    errorPaymentRequired: (array[17] || translations['en'][17]),
    errorLocked: (array[18] || translations['en'][18]),
  };
}

function mergeTranslations(defaultTranslation: NamedTranslation, customTranslation: Partial<NamedTranslation>): NamedTranslation {
  return {
    ...defaultTranslation,
    ...customTranslation
  };
}

export function getTranslation(language: string = 'auto', customTranslationsJson: string = ''): NamedTranslation {

  let filteredCustomTranslations = []
  if (customTranslationsJson && customTranslationsJson != '') {
    try {
      filteredCustomTranslations = JSON.parse(customTranslationsJson).filter(it => it.language && it.language !== '')
    } catch (e) {
      // nothing
    }
  }
  let selectedLanguage = language;

  if (language === 'auto') {
    const foundLanguage = document.documentElement.lang.trim().toLowerCase().substring(0, 2);
    if (foundLanguage && translations[foundLanguage]) {
      selectedLanguage = foundLanguage;
    } else if (foundLanguage && filteredCustomTranslations.find(it => it.language === foundLanguage)) {
      selectedLanguage = foundLanguage;
    } else {
      selectedLanguage = 'en';
    }
  }

  const translationArray = translations[selectedLanguage] || translations['en'];
  const translation = mapTranslation(selectedLanguage, translationArray);
  const customTranslation = filteredCustomTranslations.find(it => it.language === selectedLanguage)
  if (customTranslation) {
    return mergeTranslations(translation, customTranslation)
  }

  return translation
}

const translations: Translations = {
  // Arabisch
  ar: [
    "أنا إنسان",
    "التحقق جارٍ",
    "أنا إنسان",
    "الخصوصية",
    "أنا إنسان، أداة Trustcaptcha. فعِّل لبدء التحقق.",
    "التحقق جارٍ",
    "أنا إنسان، اكتمل التحقق.",
    "بدأ التحقق.",
    "اكتمل التحقق.",
    "فشل التحقق.",
    "انتهت صلاحية التحقق. يرجى البدء من جديد.",
    "فتح موقع Trustcaptcha.",
    "فتح سياسة الخصوصية.",
    "السبب",
    "خطأ غير معروف.",
    "تعذّر الوصول إلى الخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.",
    "فشل التحقق من الروبوت. يرجى المحاولة مرة أخرى.",
    "تم الوصول إلى الحد الأقصى لعمليات التحقق. يرجى التواصل مع الدعم.",
    "تم حظر التحقق. يرجى التواصل مع الدعم."
  ],
  // Weißrussisch
  be: [
    "Я не робат",
    "Праверка працягваецца…",
    "Я не робат",
    "Прыватнасць",
    "Я не робат, віджэт Trustcaptcha. Актывуйце, каб пачаць праверку.",
    "Праверка працягваецца…",
    "Я не робат, праверка завершана.",
    "Праверка пачата.",
    "Праверка завершана.",
    "Праверка не атрымалася.",
    "Тэрмін дзеяння праверкі скончыўся. Калі ласка, пачніце нанова.",
    "Адкрыць сайт Trustcaptcha.",
    "Адкрыць палітыку прыватнасці.",
    "Прычына",
    "Невядомая памылка.",
    "Сервер недаступны. Праверце падключэнне да інтэрнэту і паспрабуйце зноў.",
    "Праверка на бота не атрымалася. Паспрабуйце зноў.",
    "Дасягнуты ліміт праверак. Звярніцеся ў службу падтрымкі.",
    "Captcha заблакіравана. Звярніцеся ў службу падтрымкі."
  ],
  // Bulgarisch
  bg: [
    "Не съм робот",
    "Проверката тече…",
    "Не съм робот",
    "Поверителност",
    "Не съм робот, Trustcaptcha уиджет. Активирайте, за да започнете проверката.",
    "Проверката тече…",
    "Не съм робот, проверката е завършена.",
    "Проверката е започната.",
    "Проверката е завършена.",
    "Проверката не успя.",
    "Проверката изтече. Моля, започнете отново.",
    "Отвори уебсайта на Trustcaptcha.",
    "Отвори политиката за поверителност.",
    "Причина",
    "Неизвестна грешка.",
    "Сървърът не е достъпен. Моля, проверете интернет връзката си и опитайте отново.",
    "Проверката за бот не успя. Моля, опитайте отново.",
    "Достигнат е лимитът на проверките. Моля, свържете се с поддръжката.",
    "Captcha е блокирана. Моля, свържете се с поддръжката."
  ],
  // Bosnisch
  bs: [
    "Nisam robot",
    "Provjera traje…",
    "Nisam robot",
    "Privatnost",
    "Nisam robot, Trustcaptcha widget. Aktivirajte za pokretanje provjere.",
    "Provjera traje…",
    "Nisam robot, provjera je završena.",
    "Provjera je započeta.",
    "Provjera je završena.",
    "Provjera nije uspjela.",
    "Provjera je istekla. Molimo započnite ponovo.",
    "Otvori Trustcaptcha web stranicu.",
    "Otvori politiku privatnosti.",
    "Razlog",
    "Nepoznata greška.",
    "Server nije dostupan. Provjerite internet vezu i pokušajte ponovo.",
    "Provjera da niste robot nije uspjela. Pokušajte ponovo.",
    "Dosegnut je limit provjera. Molimo kontaktirajte podršku.",
    "Captcha je blokirana. Molimo kontaktirajte podršku."
  ],
  // Katalanisch
  ca: [
    "Sóc humà",
    "Verificació en curs…",
    "Sóc humà",
    "Privacitat",
    "Sóc humà, widget Trustcaptcha. Activa'l per iniciar la verificació.",
    "Verificació en curs…",
    "Sóc humà, verificació completada.",
    "Verificació iniciada.",
    "Verificació completada.",
    "La verificació ha fallat.",
    "La verificació ha caducat. Si us plau, torneu a començar.",
    "Obre el lloc web de Trustcaptcha.",
    "Obre la política de privacitat.",
    "Motiu",
    "Error desconegut.",
    "No s'ha pogut connectar amb el servidor. Comprova la connexió a Internet i torna-ho a provar.",
    "La verificació antibot ha fallat. Torna-ho a provar.",
    "S'ha arribat al límit de verificacions. Contacta amb el servei d'assistència.",
    "Captcha bloquejat. Contacta amb el servei d'assistència."
  ],
  // Tschechisch
  cs: [
    "Jsem člověk",
    "Ověřování…",
    "Jsem člověk",
    "Soukromí",
    "Jsem člověk, widget Trustcaptcha. Aktivujte pro zahájení ověřování.",
    "Ověřování…",
    "Jsem člověk, ověření dokončeno.",
    "Ověřování zahájeno.",
    "Ověření dokončeno.",
    "Ověření selhalo.",
    "Platnost ověření vypršela. Začněte prosím znovu.",
    "Otevřít web Trustcaptcha.",
    "Otevřít zásady ochrany osobních údajů.",
    "Důvod",
    "Neznámá chyba.",
    "Server není dostupný. Zkontrolujte připojení k internetu a zkuste to znovu.",
    "Ověření, že nejste robot, se nezdařilo. Zkuste to znovu.",
    "Bylo dosaženo limitu ověření. Kontaktujte prosím podporu.",
    "Captcha je zablokována. Kontaktujte prosím podporu."
  ],
  // Dänisch
  da: [
    "Jeg er et menneske",
    "Verificering…",
    "Jeg er et menneske",
    "Privatliv",
    "Jeg er et menneske, Trustcaptcha-widget. Aktivér for at starte verificeringen.",
    "Verificering…",
    "Jeg er et menneske, verificering gennemført.",
    "Verificering startet.",
    "Verificering gennemført.",
    "Verificeringen mislykkedes.",
    "Verificeringen er udløbet. Start venligst forfra.",
    "Åbn Trustcaptcha-webstedet.",
    "Åbn privatlivspolitikken.",
    "Årsag",
    "Ukendt fejl.",
    "Serveren kan ikke nås. Tjek din internetforbindelse, og prøv igen.",
    "Bot-verificeringen mislykkedes. Prøv igen.",
    "Verificeringsgrænsen er nået. Kontakt venligst supporten.",
    "Captcha blokeret. Kontakt venligst supporten."
  ],
  // Deutsch
  de: [
    "Ich bin ein Mensch",
    "Verifizierung läuft…",
    "Ich bin ein Mensch",
    "Datenschutz",
    "Ich bin ein Mensch, Trustcaptcha-Widget. Aktivieren um die Verifizierung zu starten.",
    "Verifizierung läuft…",
    "Ich bin ein Mensch, Verifizierung abgeschlossen.",
    "Verifizierung gestartet.",
    "Verifizierung abgeschlossen.",
    "Verifizierung fehlgeschlagen.",
    "Verifizierung abgelaufen. Bitte erneut starten.",
    "Trustcaptcha-Website öffnen.",
    "Datenschutzerklärung öffnen.",
    "Grund",
    "Unbekannter Fehler.",
    "Server nicht erreichbar. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "Die Bot-Prüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "Das Verifizierungslimit ist erreicht. Bitte wenden Sie sich an den Support.",
    "Captcha blockiert. Bitte wenden Sie sich an den Support."
  ],
  // Griechisch
  el: [
    "Είμαι άνθρωπος",
    "Επαλήθευση…",
    "Είμαι άνθρωπος",
    "Απόρρητο",
    "Είμαι άνθρωπος, εργαλείο Trustcaptcha. Ενεργοποιήστε για να ξεκινήσει η επαλήθευση.",
    "Επαλήθευση…",
    "Είμαι άνθρωπος, η επαλήθευση ολοκληρώθηκε.",
    "Η επαλήθευση ξεκίνησε.",
    "Η επαλήθευση ολοκληρώθηκε.",
    "Η επαλήθευση απέτυχε.",
    "Η επαλήθευση έληξε. Παρακαλούμε ξεκινήστε ξανά.",
    "Άνοιγμα του ιστότοπου Trustcaptcha.",
    "Άνοιγμα της πολιτικής απορρήτου.",
    "Αιτία",
    "Άγνωστο σφάλμα.",
    "Δεν είναι δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο και προσπαθήστε ξανά.",
    "Η επαλήθευση anti-bot απέτυχε. Προσπαθήστε ξανά.",
    "Έχει συμπληρωθεί το όριο επαληθεύσεων. Επικοινωνήστε με την υποστήριξη.",
    "Το Captcha έχει αποκλειστεί. Επικοινωνήστε με την υποστήριξη."
  ],
  // Englisch
  en: [
    "I am a human",
    "Verifying…",
    "I am a human",
    "Privacy",
    "I am human, Trustcaptcha widget. Activate to start verification.",
    "Verifying…",
    "I am human, verification completed.",
    "Verification started.",
    "Verification completed.",
    "Verification failed.",
    "Verification expired. Please start again.",
    "Open the Trustcaptcha website.",
    "Open the privacy policy.",
    "Reason", // sr-only prefix used in aria-label between status and reason text
    "Unknown error.", // error UNKNOWN_ERROR
    "Server not reachable. Please check your internet connection and try again.", // error COMMUNICATION_FAILURE
    "The bot verification failed. Please try again.", // error POW_FAILURE
    "Limit of verifications has been reached. Please contact support.", // error PAYMENT_REQUIRED
    "Captcha blocked. Please contact the support." // error LOCKED
  ],
  // Spanisch
  es: [
    "Soy humano",
    "Verificación…",
    "Soy humano",
    "Privacidad",
    "Soy humano, widget de Trustcaptcha. Active para iniciar la verificación.",
    "Verificación…",
    "Soy humano, verificación completada.",
    "Verificación iniciada.",
    "Verificación completada.",
    "La verificación falló.",
    "Verificación expirada. Vuelva a iniciarla.",
    "Abrir el sitio web de Trustcaptcha.",
    "Abrir la política de privacidad.",
    "Motivo",
    "Error desconocido.",
    "No se puede conectar con el servidor. Comprueba tu conexión a Internet e inténtalo de nuevo.",
    "La verificación antibot ha fallado. Por favor, inténtalo de nuevo.",
    "Se ha alcanzado el límite de verificaciones. Por favor, contacta con el soporte.",
    "Captcha bloqueado. Por favor, contacta con el soporte."
  ],
  // Estnisch
  et: [
    "Ma olen inimene",
    "Kinnitamine…",
    "Ma olen inimene",
    "Privaatsus",
    "Ma olen inimene, Trustcaptcha vidin. Aktiveerige kinnitamise alustamiseks.",
    "Kinnitamine…",
    "Ma olen inimene, kinnitamine on lõpetatud.",
    "Kinnitamine alustatud.",
    "Kinnitamine lõpetatud.",
    "Kinnitamine ebaõnnestus.",
    "Kinnitamise kehtivusaeg on lõppenud. Palun alustage uuesti.",
    "Ava Trustcaptcha veebisait.",
    "Ava privaatsuspoliitika.",
    "Põhjus",
    "Tundmatu viga.",
    "Serverit ei saa kätte. Kontrollige internetiühendust ja proovige uuesti.",
    "Boti tuvastamine ebaõnnestus. Proovige uuesti.",
    "Kinnituste limiit on täis. Palun võtke ühendust klienditoega.",
    "Captcha on blokeeritud. Palun võtke ühendust klienditoega."
  ],
  // Finnisch
  fi: [
    "Olen ihminen",
    "Vahvistus…",
    "Olen ihminen",
    "Yksityisyys",
    "Olen ihminen, Trustcaptcha-vimpain. Käynnistä vahvistus aktivoimalla.",
    "Vahvistus…",
    "Olen ihminen, vahvistus valmis.",
    "Vahvistus aloitettu.",
    "Vahvistus valmis.",
    "Vahvistus epäonnistui.",
    "Vahvistus on vanhentunut. Aloita uudelleen.",
    "Avaa Trustcaptcha-sivusto.",
    "Avaa tietosuojakäytäntö.",
    "Syy",
    "Tuntematon virhe.",
    "Palvelimeen ei saada yhteyttä. Tarkista internetyhteys ja yritä uudelleen.",
    "Bot-tarkistus epäonnistui. Yritä uudelleen.",
    "Tarkistusten enimmäismäärä on saavutettu. Ota yhteyttä tukeen.",
    "Captcha on lukittu. Ota yhteyttä tukeen."
  ],
  // Französisch
  fr: [
    "Je suis humain",
    "Vérification…",
    "Je suis humain",
    "Confidentialité",
    "Je suis humain, widget Trustcaptcha. Activer pour démarrer la vérification.",
    "Vérification…",
    "Je suis humain, vérification terminée.",
    "Vérification démarrée.",
    "Vérification terminée.",
    "La vérification a échoué.",
    "Vérification expirée. Veuillez recommencer.",
    "Ouvrir le site Trustcaptcha.",
    "Ouvrir la politique de confidentialité.",
    "Motif",
    "Erreur inconnue.",
    "Serveur injoignable. Veuillez vérifier votre connexion Internet et réessayer.",
    "La vérification anti-bot a échoué. Veuillez réessayer.",
    "La limite de vérifications a été atteinte. Veuillez contacter le support.",
    "Captcha bloqué. Veuillez contacter le support."
  ],
  // Hindi
  hi: [
    "मैं इंसान हूँ",
    "सत्यापन…",
    "मैं इंसान हूँ",
    "गोपनीयता",
    "मैं इंसान हूँ, Trustcaptcha विजेट। सत्यापन शुरू करने के लिए सक्रिय करें।",
    "सत्यापन…",
    "मैं इंसान हूँ, सत्यापन पूरा हुआ।",
    "सत्यापन शुरू हुआ।",
    "सत्यापन पूरा हुआ।",
    "सत्यापन विफल हुआ।",
    "सत्यापन की अवधि समाप्त हो गई है। कृपया पुनः प्रारंभ करें।",
    "Trustcaptcha वेबसाइट खोलें।",
    "गोपनीयता नीति खोलें।",
    "कारण",
    "अज्ञात त्रुटि।",
    "सर्वर तक नहीं पहुँच सका। कृपया अपना इंटरनेट कनेक्शन जाँचें और पुनः प्रयास करें।",
    "बॉट सत्यापन विफल रहा। कृपया पुनः प्रयास करें।",
    "सत्यापन की सीमा पूरी हो गई है। कृपया सहायता से संपर्क करें।",
    "कैप्चा अवरुद्ध है। कृपया सहायता से संपर्क करें।"
  ],
  // Kroatisch
  hr: [
    "Ja sam čovjek",
    "Provjera…",
    "Ja sam čovjek!",
    "Privatnost",
    "Ja sam čovjek, Trustcaptcha widget. Aktivirajte za pokretanje provjere.",
    "Provjera…",
    "Ja sam čovjek, provjera je dovršena.",
    "Provjera je započeta.",
    "Provjera je dovršena.",
    "Provjera nije uspjela.",
    "Provjera je istekla. Molimo započnite ponovno.",
    "Otvori Trustcaptcha web stranicu.",
    "Otvori pravila privatnosti.",
    "Razlog",
    "Nepoznata pogreška.",
    "Poslužitelj nije dostupan. Provjerite internetsku vezu i pokušajte ponovno.",
    "Provjera niste li robot nije uspjela. Pokušajte ponovno.",
    "Dosegnut je limit provjera. Molimo obratite se podršci.",
    "Captcha je blokirana. Molimo obratite se podršci."
  ],
  // Ungarisch
  hu: [
    "Ember vagyok",
    "Ellenőrzés…",
    "Ember vagyok",
    "Adatvédelem",
    "Ember vagyok, Trustcaptcha modul. Aktiválja az ellenőrzés indításához.",
    "Ellenőrzés…",
    "Ember vagyok, az ellenőrzés befejeződött.",
    "Ellenőrzés elindítva.",
    "Ellenőrzés befejezve.",
    "Az ellenőrzés sikertelen.",
    "Az ellenőrzés érvényessége lejárt. Kérjük, kezdje elölről.",
    "Trustcaptcha weboldal megnyitása.",
    "Adatvédelmi szabályzat megnyitása.",
    "Ok",
    "Ismeretlen hiba.",
    "A szerver nem érhető el. Ellenőrizze az internetkapcsolatát, és próbálja újra.",
    "A bot-ellenőrzés nem sikerült. Próbálja újra.",
    "Az ellenőrzési limit elérve. Kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal.",
    "A captcha le van tiltva. Kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal."
  ],
  // Italienisch
  it: [
    "Sono un umano",
    "Verifica…",
    "Sono un umano",
    "Privacy",
    "Sono umano, widget Trustcaptcha. Attiva per avviare la verifica.",
    "Verifica…",
    "Sono umano, verifica completata.",
    "Verifica avviata.",
    "Verifica completata.",
    "La verifica non è riuscita.",
    "Verifica scaduta. Ricomincia.",
    "Apri il sito web di Trustcaptcha.",
    "Apri l’informativa sulla privacy.",
    "Motivo",
    "Errore sconosciuto.",
    "Server non raggiungibile. Controlla la connessione a Internet e riprova.",
    "La verifica antibot non è riuscita. Riprova.",
    "Hai raggiunto il limite di verifiche. Contatta l’assistenza.",
    "Captcha bloccato. Contatta l’assistenza."
  ],
  // Koreanisch
  ko: [
    "저는 사람입니다",
    "인증 중…",
    "저는 사람입니다",
    "개인정보",
    "저는 사람입니다, Trustcaptcha 위젯입니다. 활성화하여 인증을 시작하세요.",
    "인증 중…",
    "저는 사람입니다, 인증이 완료되었습니다.",
    "인증이 시작되었습니다.",
    "인증이 완료되었습니다.",
    "인증에 실패했습니다.",
    "인증이 만료되었습니다. 다시 시작해 주세요.",
    "Trustcaptcha 웹사이트 열기.",
    "개인정보 처리방침 열기.",
    "사유",
    "알 수 없는 오류입니다.",
    "서버에 연결할 수 없습니다. 인터넷 연결을 확인하고 다시 시도해 주세요.",
    "봇 인증에 실패했습니다. 다시 시도해 주세요.",
    "인증 한도에 도달했습니다. 지원팀에 문의해 주세요.",
    "캡차가 차단되었습니다. 지원팀에 문의해 주세요."
  ],
  // Luxemburgisch
  lb: [
    "Ech sinn e Mënsch",
    "Verifikatioun…",
    "Ech sinn e Mënsch!",
    "Dateschutz",
    "Ech sinn e Mënsch, Trustcaptcha-Widget. Aktivéier fir d'Verifikatioun ze starten.",
    "Verifikatioun…",
    "Ech sinn e Mënsch, Verifikatioun ofgeschloss.",
    "Verifikatioun gestart.",
    "Verifikatioun ofgeschloss.",
    "Verifikatioun feelgeschloen.",
    "Verifikatioun ofgelaf. Probéiert et w.e.g. erneit.",
    "Trustcaptcha-Websäit opmaachen.",
    "Dateschutzerklärung opmaachen.",
    "Grond",
    "Onbekannte Feeler.",
    "Server net erreechbar. Kontrolléiert w.e.g. Är Internetverbindung an probéiert et erneit.",
    "D'Bot-Verifikatioun ass feelgeschloen. Probéiert et w.e.g. erneit.",
    "D'Limit vu Verifikatiounen ass erreecht. Kontaktéiert w.e.g. de Support.",
    "Captcha blockéiert. Kontaktéiert w.e.g. de Support."
  ],
  // Litauisch
  lt: [
    "Aš esu žmogus",
    "Patvirtinimas…",
    "Aš esu žmogus",
    "Privatumas",
    "Aš esu žmogus, Trustcaptcha valdiklis. Suaktyvinkite, kad pradėtumėte patvirtinimą.",
    "Patvirtinimas…",
    "Aš esu žmogus, patvirtinimas baigtas.",
    "Patvirtinimas pradėtas.",
    "Patvirtinimas baigtas.",
    "Patvirtinimas nepavyko.",
    "Patvirtinimo galiojimas baigėsi. Pradėkite iš naujo.",
    "Atidaryti Trustcaptcha svetainę.",
    "Atidaryti privatumo politiką.",
    "Priežastis",
    "Nežinoma klaida.",
    "Serverio pasiekti nepavyko. Patikrinkite interneto ryšį ir bandykite dar kartą.",
    "Roboto patikra nepavyko. Bandykite dar kartą.",
    "Pasiektas patikrinimų limitas. Susisiekite su pagalbos tarnyba.",
    "Captcha užblokuota. Susisiekite su pagalbos tarnyba."
  ],
  // Lettisch
  lv: [
    "Es esmu cilvēks",
    "Pārbaude…",
    "Es esmu cilvēks",
    "Privātums",
    "Es esmu cilvēks, Trustcaptcha logrīks. Aktivizējiet, lai sāktu pārbaudi.",
    "Pārbaude…",
    "Es esmu cilvēks, pārbaude pabeigta.",
    "Pārbaude sākta.",
    "Pārbaude pabeigta.",
    "Pārbaude neizdevās.",
    "Pārbaudes derīguma termiņš ir beidzies. Lūdzu, sāciet no jauna.",
    "Atvērt Trustcaptcha tīmekļa vietni.",
    "Atvērt privātuma politiku.",
    "Iemesls",
    "Nezināma kļūda.",
    "Nevar sazināties ar serveri. Lūdzu, pārbaudiet interneta savienojumu un mēģiniet vēlreiz.",
    "Robota pārbaude neizdevās. Lūdzu, mēģiniet vēlreiz.",
    "Pārbaužu limits ir sasniegts. Lūdzu, sazinieties ar atbalsta dienestu.",
    "Captcha ir bloķēta. Lūdzu, sazinieties ar atbalsta dienestu."
  ],
  // Mazedonisch
  mk: [
    "Јас сум човек",
    "Верификација…",
    "Јас сум човек",
    "Приватност",
    "Јас сум човек, Trustcaptcha виџет. Активирајте за да ја започнете верификацијата.",
    "Верификација…",
    "Јас сум човек, верификацијата е завршена.",
    "Верификацијата започна.",
    "Верификацијата заврши.",
    "Верификацијата не успеа.",
    "Верификацијата истече. Ве молиме, започнете повторно.",
    "Отвори ја веб-страницата на Trustcaptcha.",
    "Отвори ја политиката за приватност.",
    "Причина",
    "Непозната грешка.",
    "Серверот не е достапен. Проверете ја интернет врската и обидете се повторно.",
    "Проверката за бот не успеа. Обидете се повторно.",
    "Достигнат е лимитот на проверки. Контактирајте ја поддршката.",
    "Captcha е блокирана. Контактирајте ја поддршката."
  ],
  // Niederländisch
  nl: [
    "Ik ben een mens",
    "Verificatie…",
    "Ik ben een mens",
    "Privacy",
    "Ik ben een mens, Trustcaptcha-widget. Activeer om de verificatie te starten.",
    "Verificatie…",
    "Ik ben een mens, verificatie voltooid.",
    "Verificatie gestart.",
    "Verificatie voltooid.",
    "Verificatie mislukt.",
    "Verificatie verlopen. Probeer het opnieuw.",
    "Open de Trustcaptcha-website.",
    "Open het privacybeleid.",
    "Reden",
    "Onbekende fout.",
    "Server niet bereikbaar. Controleer je internetverbinding en probeer het opnieuw.",
    "De botverificatie is mislukt. Probeer het opnieuw.",
    "Het verificatielimiet is bereikt. Neem contact op met de support.",
    "Captcha geblokkeerd. Neem contact op met de support."
  ],
  // Norwegisch
  no: [
    "Jeg er et menneske",
    "Verifisering…",
    "Jeg er et menneske",
    "Personvern",
    "Jeg er et menneske, Trustcaptcha-widget. Aktiver for å starte verifiseringen.",
    "Verifisering…",
    "Jeg er et menneske, verifisering fullført.",
    "Verifisering startet.",
    "Verifisering fullført.",
    "Verifiseringen mislyktes.",
    "Verifiseringen er utløpt. Vennligst start på nytt.",
    "Åpne Trustcaptcha-nettstedet.",
    "Åpne personvernerklæringen.",
    "Årsak",
    "Ukjent feil.",
    "Serveren er ikke tilgjengelig. Sjekk internettforbindelsen og prøv igjen.",
    "Botverifiseringen mislyktes. Prøv igjen.",
    "Verifiseringsgrensen er nådd. Kontakt kundestøtten.",
    "Captcha er blokkert. Kontakt kundestøtten."
  ],
  // Polnisch
  pl: [
    "Jestem człowiekiem",
    "Weryfikacja…",
    "Jestem człowiekiem",
    "Prywatność",
    "Jestem człowiekiem, widget Trustcaptcha. Aktywuj, aby rozpocząć weryfikację.",
    "Weryfikacja…",
    "Jestem człowiekiem, weryfikacja zakończona.",
    "Weryfikacja rozpoczęta.",
    "Weryfikacja zakończona.",
    "Weryfikacja nie powiodła się.",
    "Weryfikacja wygasła. Rozpocznij ponownie.",
    "Otwórz stronę Trustcaptcha.",
    "Otwórz politykę prywatności.",
    "Powód",
    "Nieznany błąd.",
    "Brak połączenia z serwerem. Sprawdź połączenie internetowe i spróbuj ponownie.",
    "Weryfikacja antybotowa nie powiodła się. Spróbuj ponownie.",
    "Osiągnięto limit weryfikacji. Skontaktuj się z pomocą techniczną.",
    "Captcha zablokowana. Skontaktuj się z pomocą techniczną."
  ],
  // Portugiesisch
  pt: [
    "Sou humano",
    "Verificação…",
    "Sou humano",
    "Privacidade",
    "Sou humano, widget Trustcaptcha. Ative para iniciar a verificação.",
    "Verificação…",
    "Sou humano, verificação concluída.",
    "Verificação iniciada.",
    "Verificação concluída.",
    "A verificação falhou.",
    "A verificação expirou. Por favor, comece de novo.",
    "Abrir o site Trustcaptcha.",
    "Abrir a política de privacidade.",
    "Motivo",
    "Erro desconhecido.",
    "Servidor inacessível. Verifique a sua ligação à Internet e tente novamente.",
    "A verificação antibot falhou. Por favor, tente novamente.",
    "Foi atingido o limite de verificações. Por favor, contacte o suporte.",
    "Captcha bloqueado. Por favor, contacte o suporte."
  ],
  // Rumänisch
  ro: [
    "Sunt om",
    "Verificare…",
    "Sunt om",
    "Confidențialitate",
    "Sunt om, widget Trustcaptcha. Activează pentru a începe verificarea.",
    "Verificare…",
    "Sunt om, verificare finalizată.",
    "Verificare începută.",
    "Verificare finalizată.",
    "Verificarea a eșuat.",
    "Verificarea a expirat. Vă rugăm să începeți din nou.",
    "Deschide site-ul Trustcaptcha.",
    "Deschide politica de confidențialitate.",
    "Motiv",
    "Eroare necunoscută.",
    "Serverul nu poate fi accesat. Verifică conexiunea la internet și încearcă din nou.",
    "Verificarea anti-bot a eșuat. Te rugăm să încerci din nou.",
    "S-a atins limita de verificări. Te rugăm să contactezi asistența.",
    "Captcha este blocată. Te rugăm să contactezi asistența."
  ],
  // Russisch
  ru: [
    "Я человек",
    "Проверка…",
    "Я человек",
    "Конфиденциальность",
    "Я человек, виджет Trustcaptcha. Активируйте, чтобы начать проверку.",
    "Проверка…",
    "Я человек, проверка завершена.",
    "Проверка начата.",
    "Проверка завершена.",
    "Проверка не удалась.",
    "Срок действия проверки истёк. Пожалуйста, начните заново.",
    "Открыть сайт Trustcaptcha.",
    "Открыть политику конфиденциальности.",
    "Причина",
    "Неизвестная ошибка.",
    "Сервер недоступен. Проверьте подключение к интернету и попробуйте снова.",
    "Проверка на бота не пройдена. Пожалуйста, попробуйте ещё раз.",
    "Достигнут лимит проверок. Пожалуйста, свяжитесь со службой поддержки.",
    "Captcha заблокирована. Пожалуйста, свяжитесь со службой поддержки."
  ],
  // Slowakisch
  sk: [
    "Som človek",
    "Overovanie…",
    "Som človek",
    "Súkromie",
    "Som človek, widget Trustcaptcha. Aktivujte na spustenie overovania.",
    "Overovanie…",
    "Som človek, overenie dokončené.",
    "Overovanie spustené.",
    "Overenie dokončené.",
    "Overenie zlyhalo.",
    "Platnosť overenia uplynula. Začnite prosím znova.",
    "Otvoriť webovú stránku Trustcaptcha.",
    "Otvoriť zásady ochrany osobných údajov.",
    "Dôvod",
    "Neznáma chyba.",
    "Server je nedostupný. Skontrolujte pripojenie k internetu a skúste to znova.",
    "Overenie, či nie ste robot, zlyhalo. Skúste to znova.",
    "Bol dosiahnutý limit overení. Kontaktujte prosím podporu.",
    "Captcha je zablokovaná. Kontaktujte prosím podporu."
  ],
  // Slowenisch
  sl: [
    "Sem človek",
    "Preverjanje…",
    "Sem človek",
    "Zasebnost",
    "Sem človek, gradnik Trustcaptcha. Aktivirajte za začetek preverjanja.",
    "Preverjanje…",
    "Sem človek, preverjanje je končano.",
    "Preverjanje se je začelo.",
    "Preverjanje je končano.",
    "Preverjanje ni uspelo.",
    "Veljavnost preverjanja je potekla. Prosimo, začnite znova.",
    "Odpri spletno mesto Trustcaptcha.",
    "Odpri pravilnik o zasebnosti.",
    "Razlog",
    "Neznana napaka.",
    "Strežnik ni dosegljiv. Preverite internetno povezavo in poskusite znova.",
    "Preverjanje, ali niste robot, ni uspelo. Poskusite znova.",
    "Dosežena je omejitev preverjanj. Obrnite se na podporo.",
    "Captcha je blokirana. Obrnite se na podporo."
  ],
  // Albanisch
  sq: [
    "Jam njeri",
    "Verifikimi…",
    "Jam njeri",
    "Privatësia",
    "Jam njeri, vegla Trustcaptcha. Aktivizoje për të nisur verifikimin.",
    "Verifikimi…",
    "Jam njeri, verifikimi përfundoi.",
    "Verifikimi nisi.",
    "Verifikimi përfundoi.",
    "Verifikimi dështoi.",
    "Verifikimit i ka skaduar afati. Ju lutemi nisni përsëri.",
    "Hap faqen e internetit të Trustcaptcha.",
    "Hap politikën e privatësisë.",
    "Arsyeja",
    "Gabim i panjohur.",
    "Serveri nuk është i arritshëm. Ju lutemi kontrolloni lidhjen tuaj me internetin dhe provoni përsëri.",
    "Verifikimi anti-bot dështoi. Ju lutemi provoni përsëri.",
    "Është arritur kufiri i verifikimeve. Ju lutemi kontaktoni mbështetjen.",
    "Captcha është bllokuar. Ju lutemi kontaktoni mbështetjen."
  ],
  // Serbisch
  sr: [
    "Ja sam čovek",
    "Verifikacija…",
    "Ja sam čovek",
    "Privatnost",
    "Ja sam čovek, Trustcaptcha vidžet. Aktivirajte za početak verifikacije.",
    "Verifikacija…",
    "Ja sam čovek, verifikacija je završena.",
    "Verifikacija je započeta.",
    "Verifikacija je završena.",
    "Verifikacija nije uspela.",
    "Verifikacija je istekla. Molimo započnite ponovo.",
    "Otvori Trustcaptcha veb sajt.",
    "Otvori politiku privatnosti.",
    "Razlog",
    "Nepoznata greška.",
    "Server nije dostupan. Proverite internet vezu i pokušajte ponovo.",
    "Provera da niste robot nije uspela. Pokušajte ponovo.",
    "Dostignut je limit provera. Molimo kontaktirajte podršku.",
    "Captcha je blokirana. Molimo kontaktirajte podršku."
  ],
  // Schwedisch
  sv: [
    "Jag är en människa",
    "Verifiering…",
    "Jag är en människa",
    "Integritet",
    "Jag är en människa, Trustcaptcha-widget. Aktivera för att starta verifieringen.",
    "Verifiering…",
    "Jag är en människa, verifiering slutförd.",
    "Verifiering startad.",
    "Verifiering slutförd.",
    "Verifieringen misslyckades.",
    "Verifieringen har gått ut. Vänligen börja om.",
    "Öppna Trustcaptcha-webbplatsen.",
    "Öppna integritetspolicyn.",
    "Orsak",
    "Okänt fel.",
    "Det går inte att nå servern. Kontrollera din internetanslutning och försök igen.",
    "Botverifieringen misslyckades. Försök igen.",
    "Verifieringsgränsen har uppnåtts. Kontakta supporten.",
    "Captchan är blockerad. Kontakta supporten."
  ],
  // Türkisch
  tr: [
    "Ben insanım",
    "Doğrulama…",
    "Ben insanım",
    "Gizlilik",
    "Ben insanım, Trustcaptcha widget'ı. Doğrulamayı başlatmak için etkinleştirin.",
    "Doğrulama…",
    "Ben insanım, doğrulama tamamlandı.",
    "Doğrulama başlatıldı.",
    "Doğrulama tamamlandı.",
    "Doğrulama başarısız oldu.",
    "Doğrulamanın süresi doldu. Lütfen yeniden başlatın.",
    "Trustcaptcha web sitesini aç.",
    "Gizlilik politikasını aç.",
    "Sebep",
    "Bilinmeyen hata.",
    "Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edip tekrar deneyin.",
    "Bot doğrulaması başarısız oldu. Lütfen tekrar deneyin.",
    "Doğrulama sınırına ulaşıldı. Lütfen destek ile iletişime geçin.",
    "Captcha engellendi. Lütfen destek ile iletişime geçin."
  ],
  // Ukrainisch
  uk: [
    "Я людина",
    "Перевірка…",
    "Я людина",
    "Конфіденційність",
    "Я людина, віджет Trustcaptcha. Активуйте, щоб почати перевірку.",
    "Перевірка…",
    "Я людина, перевірку завершено.",
    "Перевірку розпочато.",
    "Перевірку завершено.",
    "Перевірку не вдалося виконати.",
    "Термін дії перевірки минув. Будь ласка, почніть заново.",
    "Відкрити сайт Trustcaptcha.",
    "Відкрити політику конфіденційності.",
    "Причина",
    "Невідома помилка.",
    "Сервер недоступний. Перевірте підключення до Інтернету та спробуйте ще раз.",
    "Перевірку на бота не пройдено. Спробуйте ще раз.",
    "Досягнуто ліміт перевірок. Зверніться до служби підтримки.",
    "Captcha заблоковано. Зверніться до служби підтримки."
  ],
  // Chinesisch (Mandarin)
  zh: [
    "我是人类！",
    "验证中…",
    "我是人类！",
    "隐私",
    "我是人类，Trustcaptcha 小部件。激活以开始验证。",
    "验证中…",
    "我是人类，验证已完成。",
    "验证已开始。",
    "验证已完成。",
    "验证失败。",
    "验证已过期。请重新开始。",
    "打开 Trustcaptcha 网站。",
    "打开隐私政策。",
    "原因",
    "未知错误。",
    "无法连接到服务器。请检查您的网络连接，然后重试。",
    "机器人验证失败。请重试。",
    "已达到验证次数上限。请联系客服。",
    "验证已被阻止。请联系客服。"
  ]
}

export interface Translations {
  [languageCode: string]: Translation;
}

export type Translation = [
  boxStart: string,
  boxInProgress: string,
  boxCompleted: string,
  endPrivacyPolicy: string,
  ariaLabelStart?: string,
  ariaLabelRunning?: string,
  ariaLabelDone?: string,
  srRunning?: string,
  srDone?: string,
  srFailed?: string,
  srExpired?: string,
  srTrustcaptcha?: string,
  srPrivacy?: string,
  srFailureReasonPrefix?: string,
  errorUnknown?: string,
  errorCommunicationFailure?: string,
  errorPowFailure?: string,
  errorPaymentRequired?: string,
  errorLocked?: string,
];
